import React, { memo } from 'react';
import { types as sdkTypes } from '../../util/sdkLoader';
import { formatMoney } from '../../util/currency';
import {
  LINE_ITEM_INITIAL_PAYMENT,
  LINE_ITEM_INITIAL_PAYMENT_PROVIDER,
  LINE_ITEM_PROVIDER_COMMISSION,
  LINE_ITEM_UNITS,
} from '../../util/types';

import css from './BookingBreakdown.css';

const { Money } = sdkTypes;

const LineItemModifyTotal = memo(props => {
  const { intl, transaction, isTripExtension } = props;

  // Find the initial payment line item
  const initialPaymentLineItem = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_INITIAL_PAYMENT
  );

  // Also check protectedData.initialPayment as fallback
  const initialPaymentFromProtectedData = transaction.attributes.protectedData.initialPayment;

  // Calculate the total amount from line items (excluding initial payment and provider commission)
  const totalFromLineItems = transaction.attributes.lineItems.reduce((acc, curr) => {
    const excludedLineItems = [
      LINE_ITEM_INITIAL_PAYMENT,
      LINE_ITEM_INITIAL_PAYMENT_PROVIDER,
      LINE_ITEM_PROVIDER_COMMISSION,
    ];

    // Check if this is a trip price line item that should be excluded when units exist
    const isTripPriceLineItem = curr.code === 'line-item/trip-price-regular-days' || 
                               curr.code === 'line-item/trip-price-peak-days' ||
                               curr.code === 'line-item/trip-price-regular-hours' ||
                               curr.code === 'line-item/trip-price-peak-hours';
    
    // Check if there's a units line item (which should take precedence)
    const hasUnitsLineItem = transaction.attributes.lineItems.some(item => item.code === LINE_ITEM_UNITS);

    // Exclude trip price line items if units line item exists (to avoid double counting)
    if (hasUnitsLineItem && isTripPriceLineItem) {
      return acc;
    }

    if (!excludedLineItems.includes(curr.code)) {
      acc += curr.lineTotal.amount;
    }

    return acc;
  }, 0);

  const payinTotal = transaction.attributes.payinTotal;
  
  let totalAmount;
  
  // Always show the total trip price from line items
  totalAmount = new Money(totalFromLineItems, payinTotal.currency);

  const formattedTotal = formatMoney(intl, totalAmount, 2);
  
  console.log('LineItemModifyTotal calculation:', {
    totalFromLineItems,
    totalAmount: totalAmount.amount,
    formattedTotal,
    isTripExtension,
    initialPaymentLineItem: initialPaymentLineItem?.lineTotal?.amount,
    initialPaymentFromProtectedData
  });
  
  return (
    <div className={css.lineItem}>
      <hr className={css.totalDivider} />

      <span className={css.itemTotalLabel}>Total</span>

      <span className={css.itemTotalValue}>{formattedTotal}</span>
    </div>
  );
});

export default LineItemModifyTotal;
